import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { InviteByEmailData } from '../../types';
import type { EmailInviteApi } from '../email-invite-api';

@injectable()
export class EmailInviteApiImpl extends PsHttpService implements EmailInviteApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    inviteByEmail(initData: InviteByEmailData) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/share/email',
            data: initData,
        }).then((res) => {
            return res.status as boolean;
        });
    }
}
